import { render, staticRenderFns } from "./UserViewAuthorizations.vue?vue&type=template&id=281819c2"
import script from "./UserViewAuthorizations.vue?vue&type=script&lang=js"
export * from "./UserViewAuthorizations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports